import React from 'react';
import '../styles/NotFoundPage.css';

export default function NotFoundPage() {
  return (
    <div className='error-page'>
        <h2 className='error-header'>404: Page Not Found!</h2>
    </div>
  );
}
